import persistReducer from "redux-persist/lib/persistReducer";
import storage from "redux-persist/lib/storage";
import { VendorDetailConstant } from "./VendorDetailConstant";

const initialState = {
  VendorDetailList: {},

  chargingEnableDisableList: [{}],
  chargingPointDeleteList: [{}],

  VendorDetail: {
    isLoading: false,
  },
  RequestViewVendorList: [],
  RequestView: {
    isLoading: false,
  },
};

export const VendorDetailReducers = persistReducer(
  {
    storage,
    key: "Vendordetail",
    whitelist: [],
  },
  (state = initialState, { type, payload }) => {
    switch (type) {
      case VendorDetailConstant.VENDOR_DETAIL_REQUEST: {
        return {
          ...state,
          VendorDetailList: [],
          VendorDetail: {
            isLoading: true,
          },
        };
      }
      case VendorDetailConstant.VENDOR_DETAIL_RESPONSE: {
        return {
          ...state,
          VendorDetailList: payload,
          VendorDetail: {
            isLoading: false,
          },
        };
      }

      case VendorDetailConstant.CHARGING_ENABLE_DISABLE_REQUEST: {
        return {
          ...state,
          chargingEnableDisableList: [],
          VendorDetail: {
            isLoading: true,
          },
        };
      }
      case VendorDetailConstant.CHARGING_ENABLE_DISABLE_RESPONSE: {
        return {
          ...state,
          chargingEnableDisableList: payload,
          VendorDetail: {
            isLoading: false,
          },
        };
      }

      case VendorDetailConstant.CHARGING_POINT_DELETE_REQUEST: {
        return {
          ...state,
          chargingPointDeleteList: [],
          VendorDetail: {
            isLoading: true,
          },
        };
      }
      case VendorDetailConstant.CHARGING_POINT_DELETE_RESPONSE: {
        return {
          ...state,
          chargingPointDeleteList: payload,
          deleteSuccess: true,

          //reload Vendor detail
          VendorDetail: {
            isLoading: false,
          },
        };
      }

      case VendorDetailConstant.CHARGING_POINT_ENABLE_DISABLE_REQUEST: {
        return {
          ...state,
          chargingEnableDisableList: [],
          VendorDetail: {
            isLoading: true,
          },
        };
      }
      case VendorDetailConstant.CHARGING_POINT_ENABLE_DISABLE_RESPONSE: {
        return {
          ...state,
          chargingEnableDisableList: payload,
          VendorDetail: {
            isLoading: false,
          },
        };
      }

      case VendorDetailConstant.GET_REQUEST_VIEW_VENDOR_DETAILS_REQUEST: {
        return {
          ...state,
          RequestViewVendorList: [],
          RequestView: {
            isLoading: true,
          },
        };
      }

      case VendorDetailConstant.GET_REQUEST_VIEW_VENDOR_DETAILS_RESPONSE: {
        return {
          ...state,
          RequestViewVendorList: payload,
          RequestView: {
            isLoading: false,
          },
        };
      }

      default:
        return state;
    }
  }
);
